/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CaseType,
    CaseTypeFromJSON,
    CaseTypeFromJSONTyped,
    CaseTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface CaseClass
 */
export interface CaseClass {
    /**
     * 
     * @type {string}
     * @memberof CaseClass
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseClass
     */
    name?: string | null;
    /**
     * 
     * @type {Array<CaseType>}
     * @memberof CaseClass
     */
    subTypes?: Array<CaseType> | null;
}

export function CaseClassFromJSON(json: any): CaseClass {
    return CaseClassFromJSONTyped(json, false);
}

export function CaseClassFromJSONTyped(json: any, ignoreDiscriminator: boolean): CaseClass {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'subTypes': !exists(json, 'subTypes') ? undefined : (json['subTypes'] === null ? null : (json['subTypes'] as Array<any>).map(CaseTypeFromJSON)),
    };
}

export function CaseClassToJSON(value?: CaseClass | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'subTypes': value.subTypes === undefined ? undefined : (value.subTypes === null ? null : (value.subTypes as Array<any>).map(CaseTypeToJSON)),
    };
}


